import { render, staticRenderFns } from "./reglamentos.vue?vue&type=template&id=44a5863a&scoped=true&"
import script from "./reglamentos.vue?vue&type=script&lang=js&"
export * from "./reglamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a5863a",
  null
  
)

export default component.exports